@if (patientCalls && patientCalls.data?.length > 0) {
  <div class="button-container">
    <button
      mat-flat-button
      color="primary"
      class="height-sm"
      (click)="prevPage()"
      [disabled]="index === 0">
      <mat-icon svgIcon="arrow-right" class="west"></mat-icon>
      {{ 'call_previous' | locale }}
    </button>
    <button
      mat-flat-button
      color="primary"
      class="height-sm"
      (click)="nextPage()"
      [disabled]="index + 1 === patientCalls.data?.length">
      {{ 'call_next' | locale }}
      <mat-icon svgIcon="arrow-right" class="east"></mat-icon>
    </button>
  </div>
  <div class="container">
    @if (patientCalls.data[index]; as patientCall) {
      <app-medical-record
        [call]="patientCall"
        [index]="index"
        [totalCalls]="patientCalls.total">
      </app-medical-record>
    }
  </div>
} @else {
  <div class="no-data-container">
    <span>{{ errorMessage || 'medical_records_empty_message' | locale }}</span>
  </div>
}

